import app from "./app/styles.module.scss?inline";
import index from "./index.scss?inline";
import chatbotButton from "./app/components/chatbot-button/styles.module.scss?inline";
import header from "./components/layout/header/styles.module.scss?inline";
import chat from "./app/components/chat/styles.module.scss?inline";
import aside from "./components/layout/aside/styles.module.scss?inline";
import main from "./components/layout/main/styles.module.scss?inline";
import messageAi from "./components/ui/message-ai/styles.module.scss?inline";
import messageAiModel from "./components/ui/message-ai/components/model/styles.module.scss?inline";
import messageUser from "./components/ui/message-user/styles.module.scss?inline";
import messageLoading from "./components/ui/message-loading/styles.module.scss?inline";
import question from "./components/layout/question/styles.module.scss?inline";
import fieldGroup from "./components/ui/field-group/styles.module.scss?inline";
import label from "./components/ui/label/styles.module.scss?inline";
import input from "./components/ui/input/styles.module.scss?inline";
import button from "./components/ui/button/styles.module.scss?inline";
import bottomSheet from "./components/layout/bottom-sheet/styles.module.scss?inline";
import pdfViewer from "./components/ui/pdf-viewer/styles.module.scss?inline";
import select from "./components/ui/select/styles.module.scss?inline";
import textarea from "./components/ui/textarea/styles.module.scss?inline";
import cta from "./components/layout/bottom-sheet/cta/styles.module.scss?inline";
import dynamicMultiStepForm from "./components/layout/bottom-sheet/dynamic-multi-step-form/styles.module.scss?inline";
import mobilePicker from "./components/ui/mobile-picker/styles.module.scss?inline";
import wheelDatetimePicker from "./components/ui/wheel-datetime-picker/styles.module.scss?inline";
import skeleton from "./components/ui/skeleton/styles.module.scss?inline";
import answers from "./components/ui/message-ai/components/answers/styles.module.scss?inline";
import detailData from "./components/ui/message-ai/components/detail-data/styles.module.scss?inline";
import thanks from "./components/layout/bottom-sheet/thanks/styles.module.scss?inline";
import dateInput from "./components/ui/date-input/styles.module.scss?inline";
import datetimeInput from "./components/ui/datetime-input/styles.module.scss?inline";

const styles = [
  // 重要: Shadow DOM用のベーススタイル（最初に配置）
  `
    /* Shadow DOM CSS Reset & Base Styles */
    :host {
      all: initial;
      display: block;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    }
    *, *::before, *::after {
      box-sizing: border-box;
    }
    `,
  index,
  app,
  chatbotButton,
  header,
  chat,
  aside,
  main,
  messageAi,
  messageAiModel,
  messageUser,
  messageLoading,
  question,
  fieldGroup,
  label,
  input,
  button,
  bottomSheet,
  pdfViewer,
  select,
  textarea,
  cta,
  dynamicMultiStepForm,
  mobilePicker,
  wheelDatetimePicker,
  skeleton,
  answers,
  detailData,
  thanks,
  dateInput,
  datetimeInput,
].join("");

export default styles;
